import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; // <-- IMPORTANT per ngModel
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { MatDialogModule } from '@angular/material/dialog';
import { AngularMaterialModule } from '../../../angular-material.module';

import { FilterDialogComponent } from './filter-dialog.component';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  declarations: [
    FilterDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    MatDialogModule,
    TranslateModule
  ],
  providers:    [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ]
})
export class FilterDialogModule { }
